<template>
  <b-modal
    :id="id"
    ref="createPatientModal"
    centered
    size="xxl"
    :title="$t('global.newPatient')"
    modal-class="create-patient-modal"
    qa="create-patient-modal"
    @hide="onHide"
    @hidden="$_cleanComponentData()"
    @shown="modalShown = true"
  >
    <patient-form
      v-if="modalShown"
      ref="patientForm"
      :patient="patient"
      :notes="patient.notes"
    />
    <div
      slot="modal-footer"
      class="footer-banner pr-2 pl-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            v-testing="'cancel'"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <vt-loading-button
            qa="create-patient-modal-save-button"
            class="btn-sm"
            :class="{ 'btn--primary': !createCase, 'btn__outline': createCase }"
            :params="{ promise: create.bind(null, false) }"
          >
            <i
              class="far fa-save mr-2"
              aria-hidden="true"
            />{{ $t('global.save') }}
          </vt-loading-button>
          <vt-loading-button
            v-if="createCase"
            qa="create-patient-modal-save-create-case-button"
            class="btn--primary btn-sm ml-2"
            :params="{ promise: create.bind(null, true) }"
          >
            <i
              class="far fa-chart-network mr-2"
              aria-hidden="true"
            />{{ $t('component.patient.searcher.saveAndCreateCase') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
    <b-modal
      ref="errorModal"
      hide-footer
      centered
    >
      <p class="my-4">
        {{ $t('global.operationNotAllowed') }}
      </p>
    </b-modal>
  </b-modal>
</template>

<script>

import patientResource from '@/api/resources/PatientResource'
import PatientForm from '@/components/patient/PatientForm'
import patientService from '@/api/resources/PatientService'
const ROUTE_NEW_CASE = 'newCase'
export default {
    name: 'CreatePatientModal',
    components: {
        PatientForm
    },
    props: {
        id: { type: String, required: true },
        createCase: { type: Boolean, default: false }
    },
    data() {
        return {
            modalShown: false,
            patient: {
                address: {},
                contactInformation: {},
                notes: {},
                patientIdentifiers: []
            },
            errRes: null
        }
    },
    computed: {
        okDisabled() {
            return false // TODO: validate that every required input is filled
        }
    },
    methods: {
        show() {
            this.$refs.createPatientModal.show()
        },
        async create(createCase) {
            const valid = await this.$refs.patientForm.validate()
            if (!valid) {
                return
            }
            const requestPatient = {
                ...patientService.mapFromResponseToRequest(this.$refs.patientForm.internalPatient),
                patientIdentifiers: this.$refs.patientForm.toPatientIdentifierRequest(),
                notes: this.patient.notes.text
            }
            const [err, response] = await this.toCall(patientResource.create(requestPatient))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            const patient = response
            this.showToastSuccessGlobal()
            this.$refs.createPatientModal.hide()
            if (createCase) {
                if (this.$route.name === ROUTE_NEW_CASE) {
                    this.$emit('createCaseInNewCaseRoute', patient)
                } else {
                    this.$router.push({ name: ROUTE_NEW_CASE, params: { patId: patient.patId } })
                }
            } else {
                this.$emit('created', patient)
            }
        },
        onHide() {
            this.modalShown = false
            this.$emit('hide')
        },
        hide() {
            this.$refs.createPatientModal.hide()
        }
    }
}

</script>
